import { gql } from '@apollo/client'

export const getAllRoles = gql`
  query GetAllRoles {
    allRbacRoles {
      id
      name
      displayName
      description
      scope
      isSystem
    }
  }
`

export const getUserRoles = gql`
  query GetUserRoles($userId: Int!) {
    User(id: $userId) {
      id
      userRoles {
        id
        roleId
        fundId
        scope
        createdAt
        role {
          id
          name
          displayName
          description
          scope
        }
        fund {
          id
          name
        }
      }
    }
  }
`

export const getAllPermissions = gql`
  query GetAllPermissions {
    allRbacPermissions {
      id
      name
      displayName
      category
      description
    }
  }
`
